import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.freeze.title',
        defaultMessage: 'Freeze card?',
    },
    subtitle: {
        id: 'modal.freeze.subtitle',
        defaultMessage: 'This will temporarily block all transactions',
    },
    alert: {
        id: 'modal.freeze.alert',
        defaultMessage:
            'Please note that you can only unfreeze your card by <a href="{supportLink}" target="_blank">contacting support</a>',
    },
    freeze: {
        id: 'modal.freeze.freeze',
        defaultMessage: 'Freeze',
    },
    cancel: {
        id: 'modal.freeze.cancel',
        defaultMessage: 'Cancel',
    },
})
